import { render } from "./ApprovalComponent.vue?vue&type=template&id=d8e2984c&scoped=true"
import script from "./ApprovalComponent.vue?vue&type=script&lang=js"
export * from "./ApprovalComponent.vue?vue&type=script&lang=js"

import "./ApprovalComponent.vue?vue&type=style&index=0&id=d8e2984c&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e2984c"]])

export default __exports__